import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import React from 'react';

const weeklyLogHeader = [
  {
    id: 'day',
    label: 'Day',
  },
  {
    id: 'date',
    label: 'Date',
  },
  {
    id: 'new_sites',
    label: 'New Sites Prospected',
  },
  {
    id: 'gov_edu',
    label: ' .gov/.edu Outreach',
  },
  {
    id: 'initial_outreach',
    label: 'Initial Outreach',
  },
  {
    id: 'follow_ups',
    label: 'Follow Ups',
  },
  {
    id: 'responses_received',
    label: 'Responses Received',
  },
  {
    id: 'responses_sent',
    label: 'Responses Sent',
  },
  {
    id: 'approves',
    label: 'Approves',
  },
  {
    id: 'opens',
    label: 'Opens',
  },
  {
    id: 'closes',
    label: 'Closes',
  },
  {
    id: 'email_opened',
    label: 'Email Opened',
  },
  {
    id: 'unsubscribe',
    label: 'Unsubscribe',
  },
  {
    id: 'out_of_office',
    label: 'Out of Office',
  },
  {
    id: 'notes',
    label: 'Notes',
  },
];

const WeeklyLogTableHead = () => {
  return (
    <TableHead sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}>
      <TableRow>
        {weeklyLogHeader.map(cell => (
          <TableCell
            key={cell.id}
            sx={{
              color: 'black',
              fontSize: 12,
              fontWeight: 'bold',
              borderRight: '1px solid rgba(224, 224, 224, 1)',
            }}
            align="center"
            className="head-cell-log"
            sortDirection={false}
          >
            <TableSortLabel disabled active={false}>
              {cell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default WeeklyLogTableHead;
